/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "6057b1ca61f4959a148c0d50a48a43dd5780e386";
